import { Box, Button, Input, Text } from '@dtx-company/shared-components/src'
import { CovidFormFields } from './types'
import { useFormContext } from 'react-hook-form-deprecated'
import React from 'react'
import customValidations from '../../constants/customValidations'

interface ContactInfoFormProps {
  advanceStep: () => Promise<void>
  fields: Set<string>
}

const ContactInfoForm: React.FC<ContactInfoFormProps> = ({ fields, advanceStep }) => {
  const {
    register,
    formState: { dirtyFields },
    trigger,
    errors
  } = useFormContext()

  const getErrorText = React.useCallback(
    (key: string, eText: string): string | undefined =>
      key in errors ? 'Please enter a valid ' + eText : undefined,
    [errors]
  )
  return (
    <>
      <Text mb="10px" variant="body/medium" fontWeight={600} textAlign="center">
        Contact Info
      </Text>
      {fields.has(CovidFormFields.dname) && (
        <Box width="100%" mb="18px" display="block">
          <Input
            type="text"
            placeholder="Jane Doe"
            inputProps={{
              name: CovidFormFields.dname,
              ref: register({ maxLength: 80, required: true })
            }}
            maxWidth="100%"
            error={CovidFormFields.dname in errors}
            label="Full name"
            helperText={getErrorText(CovidFormFields.dname, 'display name')}
            value=""
          />
        </Box>
      )}
      {fields.has(CovidFormFields.email) && (
        <Box width="100%" mb="18px" display="block">
          <Input
            type="email"
            label="Email"
            placeholder="you@email.com"
            value=""
            maxWidth="100%"
            error={CovidFormFields.email in errors}
            inputProps={{
              name: CovidFormFields.email,
              ref: register({ pattern: customValidations.email.pattern, required: true })
            }}
            helperText={getErrorText(CovidFormFields.email, 'email')}
          />
        </Box>
      )}
      {fields.has(CovidFormFields.phone) && (
        <Box width="100%" display="block">
          <Input
            type="tel"
            label="Mobile number"
            placeholder="1234567890"
            value=""
            maxWidth="100%"
            error={CovidFormFields.phone in errors}
            inputProps={{
              name: CovidFormFields.phone,
              ref: register({
                minLength: 6,
                maxLength: 12,
                required: true,
                pattern: customValidations.phone.pattern
              })
            }}
            helperText={getErrorText(CovidFormFields.phone, 'phone number')}
          />
        </Box>
      )}
      <Button
        sizeVariant="mobileFullWidth"
        onClick={async e => {
          e.preventDefault()
          if (await trigger(Array.from(fields))) {
            advanceStep()
          }
        }}
        colorVariant="primaryBlack"
        disabled={
          !Array.from(fields).every(v => dirtyFields[v]) ||
          Array.from(fields).some(v => v in errors)
        }
        mt={32}
      >
        Next
      </Button>
    </>
  )
}

export default ContactInfoForm
